import React from 'react'
import Card from '../shared/card/card.jsx'

const PaymentMethod = ({ cardType, cardNumEnd, btnOnClick }) => {
  let cardEnding = ''

  if(cardNumEnd !== '') {
    cardEnding = 'Card ending in *' + cardNumEnd
  }
  else {
    cardEnding = 'No card on file'
  }
  return (
    <Card
      headerTitle={'Payment Method'}
      btnText='Edit payment method'
      smallBtnText='Edit'
      btnStyle='btn btn-info btn-sm'
      btnOnClick={btnOnClick}
      noPullDown
      >
      <div className='text-center'>{cardEnding}</div>
    </Card>
  )
}


export default PaymentMethod



// WEBPACK FOOTER //
// ./src/components/billing/billing-payment.jsx